module.exports = __webpack_public_path__ + "static/media/PAULOWNIA.97270d06.jpg";